import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-office-listing', {
    mixins: [AppListing],
    data: function() {
        return {
            selected:null ,
            selectedCountries: null,
            countries: [],
            isLoading: false
        }
    },
    methods: {
        limitText (count) {
          return `and ${count} other countries`
        },
        asyncFind (query) {
            this.debounce(() => {
                // this.countriesIsLoading = true;
                //     axios.get('/countries/search'. { params: { search: query }}).then((res) => {
                //         this.countries = res.data.countries;
                //         this.countriesIsLoading = false;
                //     })
                this.isLoading = true
                console.log('query', query)
                this.filter('search', query)
                this.loadData(true)
                this.isLoading = false
            }, 700)
        },
        clearAll () {
          this.selectedCountries = null
        }
      }
});